import {useAuth} from '@/modules/auth/api'
import {useGetSettings} from '@/modules/settings/api'
import {useGetUser} from '@/modules/users/api'
import {PatientTherapySequenceMachine} from '@cypro/engine/mutators'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {useActor} from '@xstate/react'

export function useTherapySequenceActor(sequence: PatientTherapySequence) {
  const {auth} = useAuth()
  const [user] = useGetUser(auth?.user?.id || '') // use the user fetched from zero because it has groups populated & reactive, they are used to determine if the user can do certain actions
  // mirrors the server machine context: guards depend on organisation settings too
  const {settings} = useGetSettings()

  const snapshot = PatientTherapySequenceMachine.resolveState({user, sequence, settings})
  if (!snapshot) throw new Error('Could not resolve sequence snapshot.')

  return useActor(PatientTherapySequenceMachine.instance, {
    input: snapshot.context,
    snapshot: snapshot,
  })
}
